module.exports = __webpack_public_path__ + "media/images/banner/kickstarter/food_book_banner_h2-6cfe1ee75c087e456c185968cd25b9d8.jpeg";